import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { produce } from 'immer'
import { RootState } from './../../store'
import { deepMerge } from './../../utils'
import { translations } from './../../constants'

type SliceState = {
  locale?: any
}

export const setLocale = createAsyncThunk(
  '@rankmi/lms-components/locale/setLocale',
  async (locale: any) => locale
)

const localeSlice = createSlice({
  name: '@rankmi/lms-components/locale',
  initialState: {
    locale: translations
  } as SliceState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setLocale.fulfilled, (state, { payload }) => {
      const nextState = produce(state, (draff) => {
        mergeLocale(draff.locale, payload)
      })
      state.locale = nextState.locale
    })
  }
})

function mergeLocale(locale: any = {}, translates: any) {
  return deepMerge(locale, translates)
}

export const selectTranslations = createSelector(
  (state: RootState) => state.locale,
  ({ locale }) => locale
)

export default localeSlice.reducer
